import { render } from "./IdeaItem.vue?vue&type=template&id=21c4c902"
import script from "./IdeaItem.vue?vue&type=script&lang=js"
export * from "./IdeaItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__